export enum StepType {
  "Details",
  "Media",
  "Options",
  "Completed",
}
